import { render, staticRenderFns } from "./trusted_vpn.vue?vue&type=template&id=7d12c23f&scoped=true&"
import script from "./trusted_vpn.vue?vue&type=script&lang=js&"
export * from "./trusted_vpn.vue?vue&type=script&lang=js&"
import style0 from "./trusted_vpn.vue?vue&type=style&index=0&id=7d12c23f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d12c23f",
  null
  
)

export default component.exports